import React from 'react';
import { connect } from 'react-redux';
import MarketOverviewComponent from './components/MarketOverviewComponent';
import { getMarketsByBase } from '../../../../../redux/selectors/selectors';
const MarketOverview = ({ marketsByBase }) => (React.createElement(MarketOverviewComponent, { markets: marketsByBase }));
const stateToProps = (state) => ({
    marketsByBase: getMarketsByBase(state),
});
export default React.memo(connect(stateToProps)(MarketOverview));
